import { StyleSheet } from 'react-native';

import { Colors, Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

import { PRODUCT_STATUS } from '../../../Services/Enums';
import cardShadow from '../../Styles/cardShadow';

export default StyleSheet.create({
  containerStyle: theme => ({
    flex: 1,
    justifyContent: 'space-between',
    backgroundColor: theme.colors.cardBackgroundColor,
    borderRadius: 6,
    paddingHorizontal: 12,
    paddingTop: 15.5,
    paddingBottom: 12,
    ...cardShadow,
  }),
  titleContainerStyle: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  titleTextStyle: theme => ({
    marginHorizontal: 8,
    fontSize: 16.6,
    ...Fonts.type.bold,
    letterSpacing: 0,
    color: theme.colors.fixedColor,
  }),
  nameTextStyle: theme => ({
    fontSize: 24,
    fontFamily: Fonts.type.VodafoneLt,
    color: theme.colors.fixedColor,
    letterSpacing: 0,
    lineHeight: 30,
  }),
  descriptionTextStyle: theme => ({
    fontSize: 16,
    color: theme.colors.fixedColor,
    lineHeight: 22.9,
    letterSpacing: 0,
    marginTop: 7,
  }),
  statusStyle: theme => ({
    ...Fonts.type.bold,
    fontSize: 16,
    color: theme.colors.textColorTwo,
    marginTop: -4,
  }),
  statusDotStyle: status => ({
    marginRight: 8,
    backgroundColor:
      status?.toLowerCase() === PRODUCT_STATUS.ACTIVE ? Colors.true_green : Colors.fresh_orange,
    height: 10,
    width: 10,
    borderRadius: 7,
  }),
  footerContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
});
